<div class="p-5 tarjetas">
  <h3 class="titulo">Seleccionar medio de pago</h3>

  <hr />

  <!-- Info Compra -->
  <div class="container infoCompra" *ngIf="info">
    <div class="row">
      <div class="col-12">
        <div class="p-4 rounded" style="background-color: #ffffff08">
          <h5 class="mb-4">Detalles</h5>

          <h6 class="text-white">
            Concepto:
            {{ info.type == 'movie' ? 'Película ' : 'Suscripción ' }} <strong>{{ info.title }}</strong>
          </h6>
          <h6>
            <strong>Total: ${{ info.price }}</strong>
          </h6>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <!-- Agrupamiento -->
  <div class="row">
    <div class="col-12 px-4">
      <div class="list-group list-group-horizontal pb-4" id="list-tab" role="tablist">
        <a class="list-group-item list-group-item-action active" id="list-cards-list" data-toggle="list"
          href="#list-cards" role="tab" aria-controls="cards" *ngIf="ppv">Tarjeta</a>
        <a class="list-group-item list-group-item-action" id="list-cupon-list" data-toggle="list" href="#list-cupon"
          role="tab" aria-controls="cupon" *ngIf="ppv">Cupón</a>
      </div>
    </div>
  </div>

  <!-- Contenido tabs -->
  <div class="tab-content" id="nav-tabContent">

    <!-- Pago Cupon -->
    <div class="tab-pane fade" id="list-cupon" role="tabpanel" aria-labelledby="list-cupon-list">

      <div class="row">
        <div class="col-12 px-5">
          <div class="row panel-cupon rounded pt-5 pb-0" id="list-cupon" style="background-color: #ffffff08">
            <div class="col-12 mb-5 mt-xxl-5">
              <form class="text-center" [formGroup]="couponForm" (ngSubmit)="onSubmit()">
                <label class="pb-3"> ¿Tienes un cupón de pelicula? <span>Ingrese el código aquí:</span></label>

                <div class="w-100 justify-content-center d-none d-md-flex">
                  <!-- codigo cupon -->
                  <div class="campo">
                    <input class="form-control form-control-lg" type="text" placeholder="Código"
                      formControlName="codigoCupon" />

                    <ng-container
                      *ngIf="couponForm.get('codigoCupon').invalid && couponForm.get('codigoCupon').touched">
                      <div *ngIf="couponForm.get('codigoCupon').errors?.required" class="text-danger">
                        Debe ingresar un código.
                      </div>
                    </ng-container>
                  </div>

                </div>

                <div class="row d-md-none">
                  <!-- codigo cupon -->
                  <div class="col-12 mb-2">
                    <input class="form-control form-control-lg" type="text" placeholder="Código"
                      formControlName="codigoCupon" />

                    <ng-container
                      *ngIf="couponForm.get('codigoCupon').invalid && couponForm.get('codigoCupon').touched">
                      <div *ngIf="couponForm.get('codigoCupon').errors?.required" class="text-danger">
                        Debe ingresar un código.
                      </div>
                    </ng-container>
                  </div>

                </div>
                <!-- BTN PAGO -->
                <button class="btn btn-pagar pink col-12 col-lg-6 offset-lg-3 mt-5 " type="submit"
                  [ngClass]="{ disabled: !couponForm.valid }">
                  <span class="text-white"> <i class="fas fa-receipt mr-2"></i> CANJEAR</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Pago Tarjetas -->
    <div class="tab-pane fade show active" id="list-cards" role="tabpanel" aria-labelledby="list-cards-list">

      <div class="tarjetas mt-4">
        <div class="cargando" *ngIf="cargandoTarjetas">
          <h3 class="d-flex justify-content-center mb-4">Cargando medios de pago</h3>
          <div class="w-100 d-flex justify-content-center mb-3">
            <span class="spinner-border" role="status" aria-hidden="true"></span>
          </div>
        </div>

        <div class="container">
          <div *ngIf="!cargandoTarjetas">
            <!-- Lista de tarjetas -->
            <div *ngIf="listaTarjetas.length > 0">
              <div class="row">
                <div class="col-12">
                  <div class="form-check mb-2" *ngFor="let tarjeta of listaTarjetas"
                    [ngClass]="{ selected: tarjeta.selected }">
                    <label class="form-check-label d-flex justify-content-between">
                      <div (click)="seleccionarMedioPago(tarjeta.paymentProfileId)">
                        <i class="far fa-credit-card"></i>
                        <!-- <span class="brand mx-4"> {{ tarjeta.paymentProfileId }}</span> -->
                        <span class="brand mx-4"> {{ tarjeta.brand }}</span>
                        <span class="last4">
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk mr-2"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk mr-2"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk"></i>
                          <i class="fas fa-asterisk mr-2"></i>
                          {{ tarjeta.last4 }}</span>
                      </div>
                      <a class="d-flex flex-column justify-content-center pr-5"
                        (click)="eliminarTarjeta(tarjeta.paymentProfileId)">Eliminar</a>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tarjeta seleccionada (sin lista) -->
            <div class="row" *ngIf="listaTarjetas.length == 0">
              <div class="col-12 mb-3" *ngIf="tarjetaSeleccionada">
                <h5>Tarjeta seleccionada</h5>
              </div>

              <div class="col-12 mb-4" *ngIf="tarjetaSeleccionada">
                <div class="p-3 border">
                  <i class="far fa-credit-card"></i>
                  <strong class="brand mx-4"> {{ tarjetaSeleccionada.brand }}</strong>
                  <strong class="last4">
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk mr-2"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk mr-2"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk"></i>
                    <i class="fas fa-asterisk mr-2"></i>
                    {{ tarjetaSeleccionada.Last4 }}</strong>
                </div>
              </div>
            </div>

            <!-- CARGAR TARJETAS -->
            <!-- IframeCustom -->
            <div class="row" *ngIf="uniqueID">
              <div class="col-12 mb-2 py-2">
                <button class="btn btn-primary btn-block text-left p-3 px-4" (click)="agregarTarjeta()">
                  <i class="fas fa-plus"></i>
                  <strong class="last4 ml-4">Agregar nueva tarjeta</strong>
                </button>
              </div>

              <!-- <div class="col-12 col-lg-5 mb-2 py-2">
            <button class="btn btn-dark btn-block text-left p-3 px-4" (click)="ingresarTarjeta()">
              <i class="fas fa-credit-card"></i>
              <strong class="last4 ml-4">Ingresar tarjeta</strong>
            </button>
          </div> -->
            </div>

            <!-- IframeNoraml -->
            <div class="row" *ngIf="!uniqueID">
              <div class="col-12">
                <button class="btn btn-primary btn-block p-3 px-4 text-left py-2" (click)="ingresarTarjeta()">
                  <i class="fas fa-credit-card"></i>
                  <strong class="last4 ml-4">Ingresar tarjeta</strong>
                </button>
              </div>
            </div>

            <br />

            <!-- BTN PAGO -->
            <button class="btn btn-pagar pink col-12 col-lg-6 offset-lg-3 mt-3 mb-5" (click)="realizarPago()"
              [disabled]="cargandoPago || botonPagoDisabled" *ngIf="!cargandoTarjetas">
              <span *ngIf="cargandoPago" class="spinner-border spinner-border-sm mb-1 mr-2" role="status"
                aria-hidden="true"></span>
              <span> <i class="fas fa-receipt mr-2" *ngIf="!cargandoPago"></i> PAGAR</span>
            </button>

          </div>
        </div>
      </div>

    </div>
  </div>

  <br />


  <!-- BTN PAGO VIEJO -->
  <!-- <button class="btn btn-pagar pink col-12 col-lg-6 offset-lg-3 mt-3 mb-5" (click)="realizarPago()"
    [disabled]="cargandoPago || botonPagoDisabled" *ngIf="!cargandoTarjetas">
    <span *ngIf="cargandoPago" class="spinner-border spinner-border-sm mb-1 mr-2" role="status"
      aria-hidden="true"></span>
    <span> <i class="fas fa-receipt mr-2" *ngIf="!cargandoPago"></i> PAGAR</span>
  </button> -->
</div>